/** Bootstrap modal props so a nested modal stacks above an open parent modal. */
export function getNestedModalProps(level = 1) {
  const safe = Math.max(1, Number(level) || 1);
  const levelClass = safe > 1 ? ` ics-nested-modal-l${safe}` : "";
  const backdropLevelClass = safe > 1 ? ` ics-nested-modal-backdrop-l${safe}` : "";
  return {
    enforceFocus: false,
    className: `ics-nested-modal-root${levelClass}`,
    backdropClassName: `ics-nested-modal-backdrop${backdropLevelClass}`,
    dialogClassName: "ics-nested-modal-dialog",
  };
}

export const NESTED_MODAL_PROPS = getNestedModalProps(1);
